/* Pond Provisions Co – product page (6-10-2026, from the fleece underlay mockup).
   Size finder for sheet liners/underlays (switched off 7-10-2026), option dropdowns, gallery, AJAX add, Buy it now, quote panel, matching liner/underlay.
   Prices are the product's own – nothing here changes a price. */
(function () {
  'use strict';
  var R = document.getElementById('ppp'), DEl = document.getElementById('ppp-data');
  if (!R || !DEl) return;
  var D = JSON.parse(DEl.textContent), P = D.product;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (p) { return '£' + (p / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var mm = function (n) { return String(Math.round(n * 100) / 100); };
  var num = function (s) { return parseFloat(String(s).replace(',', '.')); };
  var X = ' × ', NB = ' ';
  var cur = P.variants.filter(function (v) { return v.id === D.current; })[0] || P.variants[0];

  /* ---------- sizes ---------- */
  function sizeOf(t) { var m = /([\d.]+)\s*m?\s*[x×]\s*([\d.]+)\s*m/i.exec(t || ''); if (!m) return null; var a = num(m[1]), b = num(m[2]); return { a: Math.max(a, b), b: Math.min(a, b) }; }
  var SZ = D.sheet ? P.variants.map(function (v) { var s = sizeOf(v.title); return s ? { v: v, a: s.a, b: s.b, area: s.a * s.b } : null; }).filter(Boolean) : [];
  function cover(list, nL, nW) {
    var best = null;
    list.forEach(function (s) {
      if (!(s.a >= nL - 1e-9 && s.b >= nW - 1e-9)) return;
      var better = !best || (s.v.available && !best.v.available) || (s.v.available === best.v.available && (s.area < best.area - 1e-9 || (Math.abs(s.area - best.area) < 1e-9 && s.v.price < best.v.price)));
      if (better) best = s;
    });
    return best;
  }
  var szTxt = function (s) { return mm(s.a) + NB + 'm' + X + mm(s.b) + NB + 'm'; };

  /* ---------- state ---------- */
  var S = { mode: 'pond', L: 3, W: 2, D: 0.6, grade: '25' };
  try { var sv = JSON.parse(localStorage.getItem('ppc-pond') || 'null'); if (sv && sv.L) { S.L = sv.L; S.W = sv.W; S.D = sv.D; } } catch (e) {}
  function save() { try { localStorage.setItem('ppc-pond', JSON.stringify({ L: S.L, W: S.W, D: S.D })); } catch (e) {} }
  if (D.sheet && /[?&]variant=\d/.test(location.search)) S.mode = 'sheet';

  /* ---------- variant ---------- */
  function setVariant(v, fromUser) {
    if (!v) return;
    cur = v;
    $('ppp-vid').value = v.id;
    $('ppp-price').textContent = money(v.price);
    var s = D.sheet ? sizeOf(v.title) : null;
    var basis = [];
    if (s) basis.push('For one ' + szTxt(s) + ' sheet (' + mm(s.a * s.b) + NB + 'm²)');
    if (!s && D.pack) basis.push('For one ' + D.pack + ' pack');
    if (v.sku) basis.push('SKU ' + v.sku);
    $('ppp-basis').textContent = basis.join(' · ');
    var add = $('ppp-add'), now = $('ppp-now');
    add.disabled = !v.available; now.disabled = !v.available;
    add.textContent = v.available ? 'Add to basket' : 'Out of stock';
    if (v.featured_image && v.featured_image.src) showImg(v.featured_image.src);
    if (fromUser && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    var qs = $('ppp-qs'); if (qs && !qs.dataset.touched) qs.value = s ? (S.mode === 'pond' ? 'Pond ' + mm(S.L) + ' × ' + mm(S.W) + ' m, ' + mm(S.D) + ' m deep → ' : '') + szTxt(s).replace(/ /g, ' ') + ' sheet' : '';
    var mail = $('ppp-mail'); if (mail) { var href = mail.getAttribute('href').split('&body=')[0]; mail.setAttribute('href', href + '&body=' + encodeURIComponent('Product: ' + P.title + (P.variants.length > 1 ? '\nOption: ' + v.title : '') + '\n' + location.origin + P.url + '\n\n')); }
    var wa = $('ppp-wa'); if (wa) wa.href = 'https://wa.me/' + D.wa + '?text=' + encodeURIComponent('Hello, I have a question about ' + P.title + (P.variants.length > 1 ? ' (' + v.title + ')' : '') + ' – ' + location.origin + P.url + '?variant=' + v.id);
    renderPartner();
  }

  /* ---------- size finder ---------- */
  function renderFinder() {
    if (!D.sheet || !$('ppp-find')) return;
    R.querySelectorAll('[data-act="mode"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === S.mode)); });
    $('ppp-mpond').hidden = S.mode !== 'pond'; $('ppp-msheet').hidden = S.mode !== 'sheet';
    var sheet, need = null, msg = $('ppp-msg');
    if (S.mode === 'pond') {
      ['L', 'W', 'D'].forEach(function (k) { var i = $('ppp-' + k); if (i && document.activeElement !== i) i.value = mm(S[k]); });
      var L = Math.max(S.L, S.W), W = Math.min(S.L, S.W);
      need = { a: L + 2 * S.D + 0.6, b: W + 2 * S.D + 0.6 };
      sheet = cover(SZ, need.a, need.b);
      if (sheet) { msg.className = 'ppp-msg'; msg.textContent = 'Your pond needs at least ' + mm(need.a) + ' m × ' + mm(need.b) + ' m. The smallest sheet that covers it is ' + szTxt(sheet).replace(/ /g, ' ') + '.'; }
      else { var big = SZ.reduce(function (m, s) { return !m || s.area > m.area ? s : m; }, null); msg.className = 'ppp-msg is-big'; msg.textContent = 'Your pond needs at least ' + mm(need.a) + ' m × ' + mm(need.b) + ' m — bigger than our largest sheet (' + szTxt(big).replace(/ /g, ' ') + '). Ask for a quote below and we will work out the sheets.'; sheet = null; }
    } else {
      sheet = SZ.filter(function (s) { return s.v.id === cur.id; })[0] || SZ[0];
      var as = [], sa = $('ppp-sa'), sb = $('ppp-sb');
      SZ.forEach(function (s) { if (as.indexOf(s.a) < 0) as.push(s.a); }); as.sort(function (x, y) { return x - y; });
      sa.innerHTML = as.map(function (a) { return '<option value="' + a + '"' + (a === sheet.a ? ' selected' : '') + '>' + mm(a) + ' m</option>'; }).join('');
      var bs = SZ.filter(function (s) { return s.a === sheet.a; }).map(function (s) { return s.b; }).sort(function (x, y) { return x - y; });
      sb.innerHTML = bs.map(function (b) { return '<option value="' + b + '"' + (b === sheet.b ? ' selected' : '') + '>' + mm(b) + ' m</option>'; }).join('');
      msg.className = 'ppp-msg'; msg.textContent = szTxt(sheet).replace(/ /g, ' ') + ' sheet, ' + mm(sheet.area) + ' m².' + (sheet.v.available ? '' : ' Out of stock.');
    }
    $('ppp-add').hidden = false;
    if (sheet && sheet.v.id !== cur.id) setVariant(sheet.v, true); else if (sheet) setVariant(sheet.v, false);
    if (!sheet) { $('ppp-add').disabled = true; $('ppp-now').disabled = true; }
    drawSheet(sheet, need);
  }
  function drawSheet(sheet, need) {
    var box = $('ppp-draw'); if (!box) return;
    var pondL = Math.max(S.L, S.W), pondW = Math.min(S.L, S.W);
    var sa = sheet ? sheet.a : (need ? need.a : 1), sb = sheet ? sheet.b : (need ? need.b : 1);
    var maxA = Math.max(sa, need ? need.a : 0), maxB = Math.max(sb, need ? need.b : 0);
    var Wm = Math.max(maxA / 0.62, (maxB / 0.66) * 1.6), Hm = Wm / 1.6;
    var step = Wm > 60 ? 10 : Wm > 20 ? 5 : 1;
    var pc = function (x) { return (Math.round(x * 100) / 100) + '%'; };
    var place = function (el, a, b) { el.style.cssText = 'width:' + pc(a / Wm * 100) + ';height:' + pc(b / Hm * 100) + ';left:' + pc((1 - a / Wm) * 50) + ';top:' + pc((1 - b / Hm) * 50); };
    box.style.backgroundSize = pc(step / Wm * 100) + ' ' + pc(step / Hm * 100);
    $('ppp-dg').textContent = 'Top view · ' + step + ' m grid';
    $('ppp-dt').textContent = sheet ? szTxt(sheet) + ' sheet' : 'Bigger than our largest sheet';
    var ds = $('ppp-ds'); ds.hidden = !sheet; if (sheet) place(ds, sheet.a, sheet.b);
    ds.className = 'ppp-draw__s' + (D.under ? ' is-fleece' : ' is-liner');
    var dn = $('ppp-dn'), dp = $('ppp-dp'), pond = S.mode === 'pond' && need;
    dn.hidden = !pond; dp.hidden = !pond;
    if (pond) { place(dn, need.a, need.b); place(dp, pondL, pondW); }
    var key = [];
    if (sheet) key.push('<li><i class="k-s' + (D.under ? ' is-fleece' : ' is-liner') + '"></i>' + (D.under ? 'Underlay' : 'Liner') + ' sheet, ' + esc(szTxt(sheet)) + '</li>');
    if (pond) { key.push('<li><i class="k-n"></i>Needed, ' + mm(need.a) + ' m × ' + mm(need.b) + ' m</li>'); key.push('<li><i class="k-p"></i>Pond, ' + mm(pondL) + ' m × ' + mm(pondW) + ' m, ' + mm(S.D) + ' m deep</li>'); }
    $('ppp-key').innerHTML = key.join('');
  }

  /* ---------- option dropdowns (products with options) ---------- */
  function pickByOptions(changed) {
    var sels = R.querySelectorAll('.ppp-sel'), sel = [];
    sels.forEach(function (s) { sel[+s.dataset.i] = s.value; });
    var v = P.variants.filter(function (v) { return sel.every(function (x, i) { return x == null || v.options[i] === x; }); })[0];
    if (!v && changed) {
      var ci = +changed.dataset.i;
      v = P.variants.filter(function (v) { return v.options[ci] === changed.value && v.available; })[0] || P.variants.filter(function (v) { return v.options[ci] === changed.value; })[0];
      if (v) sels.forEach(function (s) { s.value = v.options[+s.dataset.i]; });
    }
    if (v) setVariant(v, true);
  }

  /* ---------- gallery ---------- */
  function showImg(src) {
    var img = $('ppp-gimg'); if (!img) return;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var u = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
    img.removeAttribute('srcset'); img.src = u;
  }

  /* ---------- matching liner / underlay ---------- */
  var PC = {};
  function load(h) { if (!PC[h]) PC[h] = fetch(ROOT + 'products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); return PC[h]; }
  var partnerV = null;
  function renderPartner() {
    if (!D.partner || !$('ppp-xp')) return;
    R.querySelectorAll('[data-act="grade"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.v === S.grade)); });
    var h = D.partner === 'liner' ? D.liners[S.grade] : D.fleece;
    var mine = sizeOf(cur.title);
    load(h).then(function (p) {
      var box = $('ppp-xp');
      if (!p) { box.innerHTML = '<p class="ppp-x__load">This product is not available right now.</p>'; return; }
      var list = p.variants.map(function (v) { var s = sizeOf(v.title); return s ? { v: v, a: s.a, b: s.b, area: s.a * s.b } : null; }).filter(Boolean);
      var exact = mine ? list.filter(function (s) { return Math.abs(s.a - mine.a) < 1e-9 && Math.abs(s.b - mine.b) < 1e-9; })[0] : null;
      var m = exact || (mine ? cover(list, mine.a, mine.b) : null);
      if (!m) { box.innerHTML = '<p class="ppp-x__load">No matching size for this sheet – ask us for a quote.</p>'; partnerV = null; return; }
      partnerV = m.v;
      var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
      var name = p.title.split(' – ')[0];
      var spec = szTxt(m) + ' sheet, ' + (exact ? 'to match your ' + (D.partner === 'liner' ? 'underlay' : 'liner') : 'the nearest size that covers yours');
      box.innerHTML = '<div class="ppp-x__r">' + (img ? '<img src="' + esc(img) + '" alt="" width="116" height="116" loading="lazy">' : '') +
        '<div><span class="ppp-x__k">' + (D.partner === 'liner' ? 'Pond liner' : 'Underlay') + '</span><a href="' + esc(p.url + '?variant=' + m.v.id) + '">' + esc(name) + '</a><small>' + esc(spec) + '</small></div></div>' +
        '<div class="ppp-x__f"><b class="ppp-x__price">' + money(m.v.price) + '</b>' + (m.v.available ? '<button type="button" class="ppc-koi" data-act="xadd">Add the ' + (D.partner === 'liner' ? 'liner' : 'underlay') + ' too</button>' : '<span class="ppp-x__load">Out of stock</span>') + '</div>';
    });
  }

  /* ---------- basket ---------- */
  function setCount() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.ppc-bk__n').forEach(function (el) { el.textContent = c.item_count; });
      document.querySelectorAll('.ppc-bk').forEach(function (el) { el.setAttribute('aria-label', 'Basket, ' + c.item_count + ' items'); });
    }).catch(function () {});
  }
  function add(items) {
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket'); return j; }); });
  }
  function qty() { var q = parseInt($('ppp-q').value, 10); return q > 0 ? q : 1; }
  function flash(btn, txt) { var o = btn.textContent; btn.classList.add('is-done'); btn.textContent = txt; setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = o; btn.disabled = !cur.available; }, 2200); }
  function err(m) { var e = $('ppp-err'); e.textContent = m || ''; e.hidden = !m; }

  /* ---------- goes with it / similar products (Shopify recommendations) ---------- */
  function recs() {
    var box = $('ppp-recs'); if (!box || !box.dataset.url) return;
    fetch(box.dataset.url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var d = document.createElement('div'); d.innerHTML = html;
      var items = [].slice.call(d.querySelectorAll('.ppr-i')).filter(function (i) { return i.dataset.h !== P.handle; });
      if (!items.length) return;
      var type = box.dataset.type || '';
      var same = items.filter(function (i) { return i.dataset.type === type; }), other = items.filter(function (i) { return i.dataset.type !== type; });
      var goes = other.slice(0, 3), sim = same.slice(0, 4);
      if (sim.length < 4) sim = sim.concat(other.slice(3, 3 + 4 - sim.length));
      var out = '';
      if (goes.length) out += '<section class="ppr-sec is-stone" aria-labelledby="ppr-g-h"><div class="ppc-w"><h2 class="ppc-h2" id="ppr-g-h">Goes with it</h2><div class="ppr-goes">' + goes.map(function (i) { return '<article class="ppr-card">' + i.querySelector('.ppr-g').innerHTML + '</article>'; }).join('') + '</div></div></section>';
      if (sim.length >= 2) out += '<section class="ppr-sec" aria-labelledby="ppr-s-h"><div class="ppc-w"><div class="ppr-hd"><h2 class="ppc-h2" id="ppr-s-h">Similar products</h2>' + (box.dataset.all ? '<a class="ppr-all" href="' + esc(box.dataset.all) + '">See all in ' + esc(box.dataset.allT) + ' <span aria-hidden="true">→</span></a>' : '') + '</div><div class="ppr-sim">' + sim.map(function (i) { return '<article class="ppr-sc">' + i.querySelector('.ppr-s').innerHTML + '</article>'; }).join('') + '</div></div></section>';
      box.innerHTML = out;
    }).catch(function () {});
  }

  /* ---------- events ---------- */
  R.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]'); if (!t || !R.contains(t)) return;
    var a = t.dataset.act;
    if (a === 'mode') { S.mode = t.dataset.v; renderFinder(); }
    else if (a === 'img') { R.querySelectorAll('[data-act="img"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === t)); }); var img = $('ppp-gimg'); if (img) { img.removeAttribute('srcset'); img.src = t.dataset.src; } }
    else if (a === 'qty') { var q = Math.max(1, qty() + +t.dataset.d); $('ppp-q').value = q; }
    else if (a === 'now') { if (t.disabled) return; err(''); t.disabled = true; t.textContent = 'One moment…'; add([{ id: cur.id, quantity: qty() }]).then(function () { location.href = ROOT + 'checkout'; }).catch(function (x) { err(x.message); t.disabled = false; t.textContent = 'Buy it now'; }); }
    else if (a === 'quote') { var f = $('ppp-qf'); f.hidden = !f.hidden; t.setAttribute('aria-expanded', String(!f.hidden)); if (!f.hidden) { var i = f.querySelector('input[type="text"]'); if (i) i.focus(); } }
    else if (a === 'grade') { S.grade = t.dataset.v; renderPartner(); }
    else if (a === 'radd') { t.disabled = true; var o = t.textContent; t.textContent = 'Adding…'; add([{ id: +t.dataset.vid, quantity: 1 }]).then(function () { setCount(); t.textContent = 'Added'; t.classList.add('is-done'); setTimeout(function () { t.textContent = o; t.classList.remove('is-done'); t.disabled = false; }, 2200); }).catch(function (x) { t.textContent = 'Try again'; t.title = x.message; t.disabled = false; }); }
    else if (a === 'xadd') { if (!partnerV) return; t.disabled = true; t.textContent = 'Adding…'; add([{ id: partnerV.id, quantity: 1 }]).then(function () { setCount(); t.textContent = 'Added'; t.classList.add('is-done'); }).catch(function (x) { t.textContent = 'Try again'; t.title = x.message; t.disabled = false; }); }
  });
  R.addEventListener('input', function (e) {
    var t = e.target;
    if (t.id === 'ppp-qs') { t.dataset.touched = '1'; return; }
    var k = { 'ppp-L': 'L', 'ppp-W': 'W', 'ppp-D': 'D' }[t.id]; if (!k) return;
    var v = num(t.value); if (!isFinite(v) || v <= 0) return;
    S[k] = Math.min(k === 'D' ? 5 : 60, v); save(); renderFinder();
  });
  R.addEventListener('change', function (e) {
    var t = e.target;
    if (t.id === 'ppp-sa') { var a = num(t.value); var opts = SZ.filter(function (s) { return s.a === a; }).sort(function (x, y) { return x.b - y.b; }); var keep = opts.filter(function (s) { return s.b === sizeOf(cur.title).b; })[0] || opts[0]; setVariant(keep.v, true); renderFinder(); }
    else if (t.id === 'ppp-sb') { var a2 = num($('ppp-sa').value), b2 = num(t.value); var s2 = SZ.filter(function (s) { return s.a === a2 && s.b === b2; })[0]; if (s2) { setVariant(s2.v, true); renderFinder(); } }
    else if (t.classList && t.classList.contains('ppp-sel')) pickByOptions(t);
    else if (t.id === 'ppp-q' && qty() < 1) t.value = 1;
  });
  var form = $('ppp-form');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault(); err('');
    var b = $('ppp-add'); if (b.disabled) return; b.disabled = true; b.textContent = 'Adding…';
    add([{ id: cur.id, quantity: qty() }]).then(function () { setCount(); flash(b, 'Added to basket'); }).catch(function (x) { err(x.message); b.disabled = false; b.textContent = 'Add to basket'; });
  });

  /* ---------- start ---------- */
  if (D.sheet) renderFinder(); else setVariant(cur, false);
  recs();
})();
